import {ApiClient} from '../../../setup/axios/SetupAxios'
import {ListQueryParams} from '../ApiClient'

export class ChargeTypesQueryParams extends ListQueryParams {
  WithActive(value: boolean) {
    this.WithParam('active', value)
    return this
  }
  WithExcludeSettingFromClientId(value: string) {
    this.WithParam('excludeSettingFromClientId', value)
    return this
  }
  WithCategory(value: any) {
    this.WithParam('category', value)
    return this
  }
  WithFeesOnly(value: boolean) {
    this.WithParam('feesOnly', value)
    return this
  }
  WithNonFeesOnly(value: boolean) {
    this.WithParam('nonFeesOnly', value)
    return this
  }
  WithContext(value: 'legacy' | 'quoteSummary') {
    this.WithParam('context', value)
    return this
  }
}

export class ChargeTypesClient {
  static async List(params: ChargeTypesQueryParams) {
    return await ApiClient.Get('/charge-types' + params.GenerateQueryString())
  }

  static async Get(id: string) {
    return await ApiClient.Get('/charge-types/' + id)
  }

  static async Delete(id: string) {
    return await ApiClient.Delete('/charge-types/' + id)
  }

  static async Create(model: any) {
    return await ApiClient.Post('/charge-types/', model)
  }

  static async Update(id: string, patchDoc: any[]) {
    return await ApiClient.Patch('/charge-types/' + id, patchDoc)
  }
}
